import React, { useState, useEffect } from 'react'
import { Form, Button, Radio, Space, Row, Col, message, Card, Typography } from 'antd'
import { sendDataBody } from '../../../resources';
import { post_catalog } from './p_t_catalog'
import { checkEncuesta, ThanksMessage, getNextSurveyUrl, EncuestaLoading, CardHeader, NameLabel, InfoCard, onFinishFailed } from '../../utils';

const { Text } = Typography;

const frecuenciaOptions = [
    { value: 0, label: 'Nunca' },
    { value: 1, label: 'A veces' },
    { value: 2, label: '2-3 veces' },
    { value: 3, label: '4-6 veces' },
    { value: 4, label: 'A diario' },
]

const gravedadOptions = [
    { value: 0, label: 'Nada' },
    { value: 1, label: 'Leve' },
    { value: 2, label: 'Moderada' },
    { value: 3, label: 'Marcada' },
    { value: 4, label: 'Extrema' },
]

const questionCardStyle = { marginBottom: 20 }
const questionHeaderStyle = { backgroundColor: '#f0f4ff', fontSize: 14 }

const QuestionCard = ({ index, label }) => (
    <Card
        key={index}
        title={<Text>{label}</Text>}
        style={questionCardStyle}
        styles={{ header: questionHeaderStyle }}
    >
        <Row gutter={[24, 16]}>
            <Col xs={24} sm={12}>
                <Form.Item
                    label={<Text style={{ color: '#5fa1c4' }}>Frecuencia</Text>}
                    name={[index + 1, 'Frecuencia']}
                    rules={[{ required: true, message: 'Selecciona la frecuencia' }]}
                >
                    <Radio.Group>
                        <Space direction="vertical">
                            {frecuenciaOptions.map(o => <Radio key={o.value} value={o.value}>{o.label}</Radio>)}
                        </Space>
                    </Radio.Group>
                </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
                <Form.Item
                    label={<Text style={{ color: '#5fa1c4' }}>Gravedad</Text>}
                    name={[index + 1, 'Gravedad']}
                    rules={[{ required: true, message: 'Selecciona la gravedad' }]}
                >
                    <Radio.Group>
                        <Space direction="vertical">
                            {gravedadOptions.map(o => <Radio key={o.value} value={o.value}>{o.label}</Radio>)}
                        </Space>
                    </Radio.Group>
                </Form.Item>
            </Col>
        </Row>
    </Card>
)

export default function PostTraumaticoEncuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default', chain = '' }) {

    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => { init() }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'post_traumatico', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }

    const nextSurveyUrl = getNextSurveyUrl('post_traumatico', chain, idmedico, idpaciente, token, visita, session, protocolo);

    const onFinish = (values) => {
        Object.keys(values).forEach(k => {
            const newArr = [];
            Object.values(values[k]).forEach(str => newArr.push(Number(str)));
            values[k] = newArr;
        })
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            respuestas_ept1_davidson: values,
            tipo: 'post_traumatico',
            uuid: token,
            visita,
            sesion: session,
            protocolo
        }
        sendDataBody('encuestas/add', body)
            .then((rs) => message.success(rs.message))
            .then(() => init())
    };

    if (checking) return <EncuestaLoading />
    if (!encuestaNotExists) return <ThanksMessage nextUrl={nextSurveyUrl} scaleName='de estrés post traumatico' />

    return (
        <div className='parentContainer'>
            <CardHeader title="Escala de Trauma de Davidson">
                <NameLabel pacienteData={pacienteData} />
                <NameLabel pacienteData={medicoData} label="Médico: " />
                <InfoCard label="Sesión" value={session} />
            </CardHeader>

            <div className='formContainer'>
                <Form
                    name="post_traumatico_enc"
                    layout='vertical'
                    initialValues={{}}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    {post_catalog.map((label, i) => (
                        <QuestionCard key={i} index={i} label={label} />
                    ))}

                    <Form.Item style={{ marginTop: 8 }}>
                        <Button type="primary" size="large" htmlType="submit">
                            Enviar respuestas
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
